/**
 * Check if an ID is a temporary/optimistic ID (not yet persisted to the database).
 * Optimistic items use temp IDs like "temp-1234567890-abc123" and must not be used
 * in Supabase/PostgreSQL queries (UUID columns reject them).
 */
export const isOptimisticId = (id: string | undefined | null): boolean =>
  !!id && typeof id === 'string' && id.startsWith('temp-');
